import React from 'react';
import styled from 'styled-components';
import Burger from './Burger';
import { useLocation } from 'react-router-dom';

// Definiujemy styled-component z warunkową logiką
const Nav = styled.nav`
 ${({ isDupa }) => isDupa &&`
  display: none;`};

  ${({ theme, isHome }) => isHome && `
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
    background: ${theme.color.spotifyBlack};
  `}
  @media (max-width: 970px) {
    /* Dodatkowe style specyficzne dla mniejszych ekranów */
  }
`;

const Navbar = ({ isLight, isDupa }) => {
  const location = useLocation(); // Pobieramy aktualną ścieżkę
  const isHome = location.pathname === '/home'; // Sprawdzamy, czy jesteśmy na "/home"

  return (
    <Nav isHome={isHome} isDupa={isDupa}>
      {/* <div className="logo">
        Nav Bar
      </div> */}
      <Burger isLight={isLight} />
    </Nav>
  );
};

export default Navbar;